<template>
  <OwnCard
    class="preview-button-set"
    :class="`preview-button-set--${editorSide}`"
    :radius="cardRadius"
    control
  >
    <div class="h-full">
      <slot />
    </div>
  </OwnCard>
</template>

<script>
import { OwnCard } from '@/ui/OwnCard'
import { useBreakpoints } from '@/utils/useBreakpoints'

export default {
  name: 'PreviewButtonSet',
  components: { OwnCard },
  props: {
    editorSide: {
      type: String,
      required: true,
      validator: (v) => ['left', 'right'].includes(v),
    },
  },
  setup() {
    const { isDesktop } = useBreakpoints()

    return { isDesktop }
  },
  computed: {
    cardRadius() {
      const { editorSide } = this

      if (this.isDesktop) {
        return '8px'
      }

      return editorSide === 'left' ? '0 8px 8px 0' : '8px 0 0 8px'
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/breakpoints';

.preview-button-set {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  &--left {
    left: -16px;
    z-index: 1;

    @include breakpoints.respond-to('md-and-up') {
      left: -40px;
    }
  }

  &--right {
    right: -16px;
    z-index: 1;

    @include breakpoints.respond-to('md-and-up') {
      right: -40px;
    }
  }
}
</style>
